<template>
  <div class="account_index">
    <div class="account_top">
        <div class="choose_type">
          <div class="choose_left">
            <div>
                <span class="choose_label">用户ID：</span>
                <a-input
                    v-model:value="checkType.userId"
                    style="width: 200px"
                ></a-input>
            </div>
            <div>
                <span class="choose_label">账号：</span>
                <a-input
                    v-model:value="checkType.account"
                    style="width: 200px"
                ></a-input>
            </div>
            <div>
              <span class="choose_label">管理单位：</span>
              <a-select
                  v-model:value="checkType.company"
                  style="width: 200px"
                  :options="companys"
                  mode='multiple'
                  :maxTagCount="1"
                  :field-names="{ label: 'companyName', value: 'companyId'}"
                  @change="changeCompany"
                  show-search
                  :filter-option="filterOption"
                  :autoClearSearchValue="false"
                ></a-select>
            </div>
            <div>
              <span class="choose_label">变电站名称：</span>
              <a-select
                  v-model:value="checkType.substation"
                  style="width: 200px"
                  :options="substations"
                  mode='multiple'
                  :maxTagCount="1"
                  :field-names="{ label: 'substationName', value: 'substationId'}"
                  @change="changeSubstation"
                  show-search
                  :filter-option="filterOption2"
                  :autoClearSearchValue="false"
                ></a-select>
            </div>
        </div>
          <div>
            <a-button class="btn" @click="getUserInfo">查询</a-button>
            <a-button class="btn" @click="reset">重置</a-button>
          </div>
        </div>
    </div>
    <div class="account_bottom" ref="content">
      <div class="table_box">
        <div class="table_control">
          <a-button class="btn" @click="addItem(1)">新增</a-button>
          <a-button class="btn" @click="addItem(2)">编辑</a-button>
          <a-button class="btn" @click="deleteInfo">删除</a-button>
        </div>
        <a-table 
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
            :dataSource="dataSource" 
            :columns="columns" 
            :row-class-name='rowClassName'
            :scroll="{ y : heightWidth}"
            :pagination="pagination"
            @change="changePage" 
            :row-key="record => record.id"
          >
          <template v-slot:bodyCell="{ text,column}">
            <template v-if=" column.dataIndex === 'userType'">
              <span >{{arrUserType.filter(item=>{return item.dictLabel==text})[0]?.dictValue}}</span>
              <!-- {{arrUserType.filter(item=>{return item.dictLabel==text})}} -->
            </template>
          </template>
        </a-table >
          
      </div>
    </div>
    <tanchuang 
      :visible="visible"
      height="60%"
      width="60%"
      @cancleOperate="resetForm"
      :headText="'新增'"
        >
        <div style="display:flex;align-items:center;justify-content:center;height:100%">
          <a-form
          ref="formRef"
          :model="updateInfo"
          :label-col="{ span: 8,}"
          class="formStyle"
          autoComplete="off" 
          @finishFailed="finishEror"
          @finish="finish"
          
        >
        <a-row>
            <a-col :span="12">
              <a-form-item
                label="身份"
                name="userType"
                >
                <a-radio-group 
                  v-model:value="updateInfo.userType"
                  @change="changeUserType"
                  >
                <a-radio :value="1" v-if="userLoginType == 0">普通管理员</a-radio>
                <a-radio :value="2">变电站用户</a-radio>
              </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="省份"
                name="province"
                :rules="[{ required:true, message: '不能为空' }]"
                >
                <a-select
                  ref="select"
                  v-model:value="updateInfo.province"
                  style="width: 200px"
                  :options="provinces"
                  :mode= "updateInfo.userType == 1 ? 'multiple' : ''"
                  :maxTagCount="2"
                  :field-names="{ label: 'regionName', value: 'regionCode'}"
                  @change="changeProvince"
                  @select="selectType"
                  @focus="handleFocusType "
                  show-search
                  :filter-option="filterOption3"
                  :autoClearSearchValue="false"
                ></a-select>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item
                label="城市"
                name="city"
                >
                <!-- :rules="[{ required:updateInfo.userType == 1 ? false : true, message: '不能为空' }]" -->
                <a-select
                  ref="selectCity"
                  v-model:value="updateInfo.city"
                  style="width: 200px"
                  :disabled="updateInfo.userType == 1 ? true : false"
                  :options="citys"
                  :field-names="{ label: 'regionName', value: 'regionCode'}"
                  @change="changeCity"
                  @focus="handleFocusCity"
                  show-search
                  :filter-option="filterOption3"
                  :autoClearSearchValue="false"
                ></a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="基层单位名称"
                name="companyName"
                >
                <a-select
                  ref="selectCompanyName"
                  v-model:value="updateInfo.companyName"
                  style="width: 200px"
                  :options="companyNames"
                  :field-names="{ label: 'companyName', value: 'companyId'}"
                  :disabled="updateInfo.userType == 1 ? true : false"
                  @change="changeCompanyName"
                  @focus="handleFocusCompanyName"
                  show-search
                  :filter-option="filterOption"
                  :autoClearSearchValue="false"
                ></a-select>
                <a-form-item
                name="newCompanyName"
                :rules="[{ required:updateInfo.companyName !== '自定义' ? false : true, message: '不能为空' }]"
                >
                  <!-- 新增基层单位输入框 -->
                  <a-input
                    v-model:value="updateInfo.newCompanyName"
                    style="width: 150px"
                    v-if="companyNameType && updateInfo.userType == 2 "
                  ></a-input>
                  <a-button type="primary" v-if="companyNameType && updateInfo.userType == 2 " @click="addNewCompanyName" class="addBtn">添加</a-button>
                </a-form-item>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item
                label="基层单位ID"
                name="companyID"
                
                >
                <!-- :rules="[{ required:true, message: '不能为空' }]" -->
                <a-input
                  v-model:value="updateInfo.companyID"
                  style="width: 200px"
                  :disabled="true"
                  placeholder="添加后自动生成id"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="变电站名称"
                name="substationName"
                
                >
                <!--  -->
                <a-select
                  ref="selectSubstationName"
                  v-model:value="updateInfo.substationName"
                  style="width: 200px"
                  :options="stationsName"
                  :disabled="updateInfo.userType == 1 ? true : false"
                  :field-names="{ label: 'substationName', value: 'substationId'}"
                  @change="changeSubstationName"
                  @focus="handleFocusSubstationName"
                  show-search
                  :filter-option="filterOption2"
                  :autoClearSearchValue="false"
                ></a-select>
                <!-- 新增变电站输入框 -->
                <a-form-item 
                  name="newSubstationName"
                  :rules="[{ required:updateInfo.substationName !== '自定义' ? false : true, message: '不能为空' }]"
                >
                  <a-input
                    v-model:value="updateInfo.newSubstationName"
                    style="width: 150px"
                    v-if="stationsNameType && updateInfo.userType == 2 "
                  ></a-input>
                  <a-button type="primary" v-if="stationsNameType && updateInfo.userType == 2 " @click="addNewSubstationName" class="addBtn">添加</a-button>
                </a-form-item>
                
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item
                label="变电站ID"
                name="stationID"
                
                >
                <!-- :rules="[{ required:true, message: '不能为空' }]" -->
                <a-input
                  v-model:value="updateInfo.stationID"
                  :disabled="true"
                  placeholder="添加后自动生成id"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="联系人姓名"
                name="contactName"
                :rules="[{ max:20, message: '不能超过20字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.contactName"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item
                label="联系人电话"
                name="contactPhone"
                :rules="[{ max:11, message: '不能超过11字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.contactPhone"
                  style="width: 200px"
                  
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="数据推送邮箱1"
                name="dataPushEmail1"
                :rules="[{ max:20, message: '不能超过20字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.dataPushEmail1"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item
                label="短信提示手机号1"
                name="smsPromptPhone1"
                :rules="[{ max:11, message: '不能超过11字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.smsPromptPhone1"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="数据推送邮箱2"
                name="dataPushEmail2"
                :rules="[{ max:20, message: '不能超过20字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.dataPushEmail2"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item
                label="短信提示手机号2"
                name="smsPromptPhone2"
                :rules="[{ max:11, message: '不能超过11字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.smsPromptPhone2"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <!-- <a-row>
            <a-col :span="12">
              <a-form-item
                label="用户ID"
                name="userID"
                :rules="[{ required:true, message: '不能为空' }]"
                >
                <a-input
                  v-model:value="updateInfo.userID"
                  :disabled="true"
                  style="width: 200px"
                >{{updateInfo.userID }}</a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item
                label="产品编码"
                name="productCode"
                :rules="[{required:true, massage:'不能为空'}]"
                >
                <a-select
                  v-model:value="updateInfo.productCode"
                  style="width: 200px"
                  :options="productCodes"
                  :maxTagCount="1"
                  :field-names="{ label: 'dictLabel', value: 'dictValue'}"
                  @change="changeProductCode"
                ></a-select>
              </a-form-item>
            </a-col>
          </a-row> -->
          <a-row>
            <a-col :span="12">
              <a-form-item
                label="账号"
                name="userName"
                :rules="[{required:true, max:20, message: '不能超过20字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.userName"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item
                label="密码"
                name="password"
                :rules="[{required:true, max:3, message: '不能超过3字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.password"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row >
            <a-col :span="12">
              <a-form-item
                label="变电站电压等级"
                name="substationVoltageLevel"
              >
                <a-select
                  ref="substationVoltageLevel"
                  v-model:value="updateInfo.substationVoltageLevel"
                  style="width: 200px"
                  :options="substationVoltageLevelList"
                  :field-names="{ label: 'dictValue', value: 'dictLabel'}"
                  @change="changesubstationVoltageLevel"
                ></a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row style="justify-content:center;">
            <a-col>
              <a-form-item>
                <a-button class="btn_quxiao" @click="resetForm">取消</a-button>
                <a-button class="btn_ok btn" html-type="submit" @click="submit">确定</a-button>
              </a-form-item>
            </a-col>
          </a-row>
          
          </a-form>
        </div>
    </tanchuang>
    <tanchuang 
      :visible="visible2"
      height="60%"
      width="60%"
      @cancleOperate="resetForm"
      :headText="'编辑'"
        >
        <div style="display:flex;align-items:center;justify-content:center;height:100%">
          <a-form
          ref="formRef"
          :model="updateInfo"
          :label-col="{ span: 11 }"
          :wrapper-col="{ span: 14 }"
          class="formStyle"
          autoComplete="off" 
          @finishFailed="finishEror2"
          @finish="finish2"
        >
         
          <a-row>
            <a-col :span="10">
              <a-form-item
                label="联系人姓名"
                name="contactName"
                :rules="[{ max:20, message: '不能超过20字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.contactName"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item
                label="联系人电话"
                name="contactPhone"
                :rules="[{ max:11, message: '不能超过11字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.contactPhone"
                  style="width: 200px"
                  
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="10">
              <a-form-item
                label="数据推送邮箱1"
                name="dataPushEmail1"
                :rules="[{ max:20, message: '不能超过20字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.dataPushEmail1"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item
                label="短信提示手机号1"
                name="smsPromptPhone1"
                :rules="[{ max:11, message: '不能超过11字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.smsPromptPhone1"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="10">
              <a-form-item
                label="数据推送邮箱2"
                name="dataPushEmail2"
                :rules="[{ max:20, message: '不能超过20字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.dataPushEmail2"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
            <a-col :span="10">
              <a-form-item
                label="短信提示手机号2"
                name="smsPromptPhone2"
                :rules="[{ max:11, message: '不能超过11字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.smsPromptPhone2"
                  style="width: 200px"
                ></a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="10">
              <a-form-item
                label="密码"
                name="password"
                :rules="[{required:false, max:3, message: '不能超过3字符!' }]"
                >
                <a-input
                  v-model:value="updateInfo.password"
                  style="width: 200px"
                ></a-input >
              </a-form-item>
            </a-col>
          </a-row>
          <a-row style="justify-content:center;">
            <a-col>
              <a-form-item>
                <a-button class="btn_quxiao" @click="resetForm">取消</a-button>
                <a-button class="btn_ok btn" html-type="submit" >确定</a-button>
              </a-form-item>
            </a-col>
          </a-row>
          </a-form>
        </div>
    </tanchuang>
    <tanchuang
    :visible="deleteModal"
    height="20%"
    width="30%"
    :showControl="true"
    @cancleOperate="cancleOperate"
    @sureOperate="deleteSure"
    :headText="'删除'"
    >
    <p  class="deleteText">正在删除</p>
    </tanchuang>
  </div>
</template>

<script>
import tanchuang from '@/components/tanchuang'
import { text } from 'body-parser'
import { 
  getTopRegionList,
  getRegionListByCode,
   getCompanyOptionByRegion,
   getSubstationOptionByCompany,
   getUserList,
   addUser,
   editUser,
   delUser,
   getDictDataByDictType,
   getCompanyNumByRegion,
   getSubstationNumByCompany
  } from '../../api/account'
export default {
  data() {
    return {
      checkType:{
        userId:"",
        account:"",
        company:[],
        city:[],
        province:[],
        substation:[]
      },
      companys:[],  //管理单位下拉框数据
      substations:[],
      dataSource:[],
      columns:[
      {
        title:'用户id',
        dataIndex:'userId',
        key:'userId'
      },
      {
        title:'用户类型',
        dataIndex:'userType',
        key:'userType'
      },
      {
        title:'省份',
        dataIndex:'provinceName',
        key:'provinceName'
      },
      {
        title:'城市',
        dataIndex:'cityName',
        key:'cityName'
      },
      {
        title:'账号',
        dataIndex:'userName',
        key:'userName'
      },
      {
        title:'管理单位',
        dataIndex:'companyName',
        key:'companyName'
      },
      {
        title:'变电站名称',
        dataIndex:'substationName',
        key:'substationName'
      },
      {
        title:'联系人姓名',
        dataIndex:'contactName',
        key:'contactName'
      },
      {
        title:'联系人电话',
        dataIndex:'contactPhone',
        key:'contactPhone'
      }],
      selectedRowKeys:[],
      selectedRows : [],
      heightWidth:100,
      pagination: { //分页设置
        //  每条数量
          current: 1,
          total: '',
          pagesize:10,
          // 可改变本页的条数
          pageSizeOptions:['10','20','30','50','100'],
          showSizeChanger: true,
          showQuickJumper : true,
          showTotal :(total =>`共${total}条`)
        },
      visible:false,
      visible2:false, //编辑的
      deleteModal:false,  //删除的
      updateInfo: {
        userType:2, //用户类型
        province:"",  //省份
        city:"",   //城市
        companyName:"",  //基层单位名称
        newCompanyName:"", //新增基层单位
        companyID:"", //基础单位id
        substationName:"",  //变电站名称
        newSubstationName:"", //新增变电站
        stationID:"", //变电站id
        contactName:"", //联系人姓名
        contactPhone:"",  //联系人电话
        dataPushEmail1:"",  //邮箱1
        smsPromptPhone1:"", //短信提示1
        dataPushEmail2:"",  //邮箱2
        smsPromptPhone2:"",  //短信提示2
        userID:"",  //用户ID
        productCode:"",  //产品编码
        userName:"",  //账号
        password:"",   //密码
        substationVoltageLevel:"", //电压等级
      },
      companyNameType:false,  //判断新增基层单位输入框
      stationsNameType:false,   //判断新增变电站名称输入框
      provinces:[],  //省份下拉框
      citys:[],      //城市下拉框
      companyNames:[],  //基层单位名称下拉框数据
      stationsName:[],  //变电站下拉框
      productCodes:[], //产品编码下拉框数据
      substationVoltageLevelList:[],  //电压等级
      updateType:1,
      // modeType:"multiple",
      notUse:false,
      // arrUserId:[], //普通用户userid合集
      arrUserType:[], //用户类型字典合集
      userLoginType:"",//用户登录类型
      resultCompanyId:[],//拆分后的基层单位Id
      areaparam:[], //列表查询省市区参数集合
    }
  },
  components : {
    tanchuang
  },
  mounted() {
    this.getDicType()
    this.setProvinceData()
    this.setCompanyData()
    this. getTableList()
    this.onWidnowResize()
    addEventListener('resize',this.onWidnowResize,false);
    this.userLoginType =JSON.parse(localStorage.getItem("loginInfo"))? JSON.parse(localStorage.getItem("loginInfo")).userType : "" ;
  },
  beforeUnmount() {
    removeEventListener('resize',this.onWidnowResize)
  },
  methods : {
    //设置省份
    setProvinceData() {
      getTopRegionList().then(res => {
        if(res.success) {
          this.provinces = res.data
        }
      })
      
    },
    //设置城市
    setCityData(query) {
      getRegionListByCode(query).then(res => {
        if(res.success) {
          this.citys = res.data
        }
      })
    },
    //获取基层单位
    setCompanyData() {
      getCompanyOptionByRegion().then(res => {
        if(res.data) {
          // this.companys = JSON.parse(JSON.stringify(res.data))
          //确保基层单位id的唯一性：将省+市+基层的id拼接
          res.data.forEach((item)=>{
            if(item.companyName !== "" && item.companyId !== ""){  //过滤掉单位id和name为空的数据
                this.companys.push({
                companyId:item.province+'-'+item.city+'-'+item.companyId,
                companyName:item.companyName,
                city:item.city,
                province:item.province
              })
            }
            
          })
         /**
          * 默认全部选中
          * 将获取变电站需要的参数添加进去
          */
          res.data.forEach(item => {
            this.checkType.city.push(item.city)
            this.checkType.province.push(item.province)
            // this.checkType.company.push(item.companyId)
          })
        }
        this.getSubstationData()
      })
    },
    //选择管理单位事件
    changeCompany(e,option) {
      this.resultCompanyId = e.map(item=>{
        const newArr = item.split('-')
        return newArr[newArr.length - 1]
      })
      // console.log(this.resultCompanyId,'单位id')
      this.checkType.city = []
      this.checkType.province = []
      this.checkType.company = e
      this.areaparam = []
      option.forEach(item => {
        const newArr = item.companyId.split('-')
        const result  = newArr[newArr.length - 1]
        this.areaparam.push({
          province:item.province,
          city:item.city,
          companyId:result,
        })
      })
      //选择单位时调变电站，将参数给变电站接口
      this.getSubstationData()
    },
    //管理单位搜索过滤
    filterOption(inputValue,option){
      // console.log(inputValue,option.companyName);
      if(!option.companyName){
        return
      }else{
        return option.companyName.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
      } 
    },
     //获取变电站
     getSubstationData() {
      getSubstationOptionByCompany(this.areaparam).then(res => {
          if(res.data) {
            this.substations = [] 
            res.data.forEach((item)=>{
              if(item.substationName !== "" && item.substationId !== ""){  //过滤为空的数据
                this.substations.push({
                  "companyId": item.companyId,
                  "province": item.province,
                  "city": item.city,
                  "substationName": item.substationName,
                  "companyName": item.companyName,
                  "substationNum": item.substationNum,
                  "substationId":item.substationId
                })
              }
            })
           
          }
          
      })
    },
    //选择变电站名称
    changeSubstation(e,option) {
      this.checkType.substation = e
    },
    //变电站搜索过滤
    filterOption2(inputValue,option){
      if(!option.substationName){
        return
      }else{
        return option.substationName.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
      }
      
    },
    //获取列表数据
    getTableList(){
      let params ={
        userId:this.checkType.userId,
        areaParam:this.areaparam,
        substationId:this.checkType.substation.length > 0 ? this.checkType.substation.join(",") : null,
        userName:this.checkType.account,
        pagesize:this.pagination.pagesize,
        pagenum : this.pagination.current
      }
      // console.log(params,'表格参数') 
      getUserList(params).then(res => {
        if(res.data){
          this.selectedRowKeys =[];
          this.selectedRows = [];
          this.dataSource = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    //字典
    getDicType(){
      let query = {
        dicType:'USER_TYPE'
      }
      getDictDataByDictType(query).then((res)=>{
         res.data.forEach((el)=>{
          this.arrUserType.push({
            'dictLabel':el.dictLabel,
            'dictValue':el.dictValue
          })
         })
      })
    },
    //表格选中事件
    onSelectChange(selectedRowKeys,selectedRows) {
        this.selectedRowKeys = selectedRowKeys;
        this.selectedRows = selectedRows;
    },
    rowClassName(_record,index) {
      return index % 2 === 0 ? 'table-striped' : null;
    },
    changePage(page){
        this.pagination.current = page.current;
        this.pagination.pagesize = page.pageSize;
        this.getTableList()
    },
    onWidnowResize() {
      let content = this.$refs.content.clientHeight - 90 - 64;
      this.heightWidth = content;
      let container = document.querySelector('.ant-table-body');
      container.style.height = content + 'px';
    },
    //取消表单
    resetForm() {
      this.$refs.formRef.resetFields()
      this.visible = false;
      this.visible2 = false;
      this.companyNameType = false;
      this.stationsNameType = false;
    },
    //确认新增表单提交
    finish(values){
      /**
       * 隐藏了用户id和产品编码
       * 当用户类型为2时的规则
       * 用户ID = 省份+城市+基层单位+变电站+产品编码(用0代替)
       * 
       */
      
      // if(this.updateInfo.userType == 2){
      //   this.arrUserId[4] = 0;
      //   this.updateInfo.userID = this.arrUserId.join("");
      // }
      let data = {
          userType:this.updateInfo.userType, //用户类型
          province:this.updateInfo.userType == 1 ? this.updateInfo.province.join(",") : this.updateInfo.province,  //省份
          city:this.updateInfo.city,   //城市
          companyName:this.updateInfo.companyName == '自定义'? "" : this.updateInfo.companyName,  //基层单位名称
          companyId:this.updateInfo.companyID, //基层单位id
          substationName:this.updateInfo.substationName == '自定义'? "" : this.updateInfo.substationName,  //变电站名称
          substationId:this.updateInfo.stationID, //变电站id
          contactName:this.updateInfo.contactName, //联系人姓名
          contactPhone:this.updateInfo.contactPhone,  //联系人电话
          dataPushEmail1:this.updateInfo.dataPushEmail1,  //邮箱1
          smsPromptPhone1:this.updateInfo.smsPromptPhone1, //短信提示1
          dataPushEmail2:this.updateInfo.dataPushEmail2,  //邮箱2
          smsPromptPhone2:this.updateInfo.smsPromptPhone2,  //短信提示2
           //userId:this.updateInfo.userID,  //用户ID  后端生成id，前端不传
          productCode:this.updateInfo.productCode,  //产品编码
          userName:this.updateInfo.userName,  //账号
          password:this.updateInfo.password,  //密码
          substationVoltageLevel:this.updateInfo.substationVoltageLevel
        };
          // console.log('新增数据',data)
        addUser(data).then((res)=>{
          if(res.success){
            this.getTableList()
            this.visible = false
            this.$message.info(res.info)
          }else{
            this.$message.info(res.info)
          }
            
          })
     
    },
    finishEror(e) {
      this.visible = true
    },
    //确认编辑表单提交
    finish2(values){
     let id = ""
      for(let i in this.updateInfo ){
        if(i == "id"){
          id = this.updateInfo[i]
        }
      }
     let query = {
      id:id,
      contactName:values.contactName,
      contactPhone:values.contactPhone,
      dataPushEmail1:values.dataPushEmail1,
      dataPushEmail2:values.dataPushEmail2,
      password:values.password ,
      smsPromptPhone1: values.smsPromptPhone1,
      smsPromptPhone2:values.smsPromptPhone2,
     }
    //  console.log('编辑传参',query);
     editUser(query).then((res)=>{
      if(res.success){
        this.visible2 = false;
        this.pagination.current = 1;
        this.getTableList()
        this.$message.info(res.info)
      }else{
        this.$message.info(res.info)
      }
      
     })
    },
    //新增、编辑
    addItem(type) {
      this.updateInfo.userType = type
      this.updateType = type
      this.updateInfo = {
        userType:2  //选择身份类型
      }
      if(type == 1 ) {//新增
          this.visible = true
          
      }else if(type ==2) {//编辑
        
        if(this.selectedRowKeys.length == 0 || !this.selectedRowKeys) {
            this.$message.info('请选择需要修改的行')
            return
        }
        if(this.selectedRowKeys.length > 1) {
            this.$message.info('只能修改一条数据')
            return
        }
        this.updateInfo = Object.assign({}, this.selectedRows[0]) 
        this.visible2 = true
      }
      this.getproductCode();  //获取产品类
    },
   
    //删除
    deleteInfo() {
        if(this.selectedRowKeys.length == 0 || !this.selectedRowKeys) {
                this.$message.info('请选择需要删除的数据')
                return
            }
        this.deleteModal = true;
    },
    //确认删除
    deleteSure() {
        let id = []
        this.selectedRows.forEach((item,index) => {
          id.push(item.id)
        })
        let query = {
          ids:id.join(",")
        };
        delUser(query).then(res => {
            if(res.success){
              this.$message.info(res.info)
              this.deleteModal = false;
              this.pagination.current = 1
              this.getTableList();
              this.setCompanyData();
              this.getSubstationData();
              this.selectedRows.length = 0
            }else{
              this.$message.info(res.info)
            } 
            
        })
    },
    //取消删除
    cancleOperate() {
        this.deleteModal = false;
    },
    
    
   
    //获取产品类数据
    getproductCode(){
      let query ={
        dicType:'PRODUCT_TYPE_CODE'
      }
      getDictDataByDictType(query).then(res=>{
        if(res.data){
          this.productCodes = res.data
          this.updateInfo.productCode = res.data[0].dictLabel
          // console.log( this.updateInfo.productCode,'产品编码');
        }
      });
      //电压等级
      let data={
        dicType:'SUBSTATION_VOLTAGE_LEVEL'
      }
      getDictDataByDictType(data).then(res=>{
        this.substationVoltageLevelList = res.data
        
      })
    },
    
    
    //选择省份事件
    changeProvince(e,option) {
      //1：普通用户 2：变电站用户
      if(this.updateInfo.userType == 1) {
        this.updateInfo.province = e
        //拼接用户ID
        // if(e.length > 0){
        //   this.updateInfo.userID = e.join("")+'gg';
        // }else if(e.length == 0){
        //   this.updateInfo.userID = ""
        // }
      }else if(this.updateInfo.userType == 2){
        let query = {
          regionCode:option.regionCode
        }
        this.setCityData(query)
        this.updateInfo.province = e;
        /**
         * 当选中省份的时候清空基层单位和变电站下拉框的值
         */
          this.updateInfo.city = ""; //城市
          this.companyNames = ""; //基层单位下拉框list
          this.updateInfo.companyName = ""; //基层单位绑定的值
          this.updateInfo.companyID = "";
          this.stationsName = "";  //变电站下拉框list
          this.updateInfo.substationName = ""; //变电站绑定的值
          this.updateInfo.stationID = ""; //变电站ID
         
      }
      
    },
    //判断是走普通管理员 还是 变电站用户 然后调不同的方法
    selectType(e,option){
       this.updateInfo.userType === 1 ? this.select() : this.selectProvince(e,option)
    },
    select(){
    },
    //省份单选，选中事件
    selectProvince(e,option){
      // this.arrUserId[0] = e
      // this.updateInfo.userID = this.arrUserId.join("")
      this.$refs.select.blur()  //选中之后失去焦点
    },
    handleFocusType(){
      this.updateInfo.userType === 1 ? this.handleFocus() : this.handleFocusProvince()
    },
    handleFocus(){},
    handleFocusProvince(){
      //获取焦点时清空
      this.updateInfo.province = ""
    },
    //省份城市共用一个搜索过滤
    filterOption3(inputValue,option){
      if(!option.regionName){
        return
      }else{
        return option.regionName.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
      }
      
    },
    //选择管理员或普通用户
    changeUserType(e) {
      //普通用户
      const { productCode }= this.updateInfo
          this.updateInfo = {
            userType : e.target.value == 1 ? 1 : 2
          }
          this.updateInfo.productCode  = productCode 
    },
    //选中城市事件
    changeCity(e){
      // this.arrUserId[1] = e;
      // this.updateInfo.userID = this.arrUserId.join("");
      this.$refs.selectCity.blur();
      this.updateInfo.companyName = ""; //基层单位绑定的值
      this.updateInfo.companyID = "";
      this.stationsName = "";  //变电站下拉框list
      this.updateInfo.substationName = "";
      this.updateInfo.stationID = ""; //变电站ID
      this.companyNameType = false;
      this.stationsNameType = false;
      //根据省市查询基层单位
      let query = [{
        province:this.updateInfo.province,
        city:this.updateInfo.city
      }]
      getCompanyOptionByRegion(query).then((res)=>{
        this.companyNames=JSON.parse(JSON.stringify(res.data))
        this.companyNames.push({
          companyName:"自定义",
          companyId:-1
        })
      })
    },
    handleFocusCity(){
      this.updateInfo.city = "";
    },
    //基层单位名称事件
    changeCompanyName(e,option){
      this.updateInfo.companyName = option.companyName  //将选中的名称赋值给基层单位名称
      if( option.companyName == "自定义"){
        this.updateInfo.companyID = "";
        this.companyNameType = true;
      }else{
        this.updateInfo.companyID = e;  //将基层单位id 赋值给单位ID
        this.companyNameType = false;
      }
      // this.arrUserId[2] = e;
      // this.updateInfo.userID = this.arrUserId.join("");
      this.$refs.selectCompanyName.blur();  //选中之后失去焦点
      this.stationsName = "";  //变电站下拉框list
      this.updateInfo.substationName = "";
      this.updateInfo.stationID = ""; //变电站ID
       let params = [{
        city:this.updateInfo.city,
        companyId:option.companyName == "自定义" ? -1 : this.updateInfo.companyID,
        province:this.updateInfo.province
      }]
      getSubstationOptionByCompany(params).then((res)=>{
         this.stationsName = JSON.parse(JSON.stringify(res.data))
          this.stationsName.push({
            substationName:"自定义",
            substationId:-1
          })
      })
    },
    //获取焦点
    handleFocusCompanyName(){
      this.updateInfo.companyName = "";
      this.updateInfo.companyID = ""
    },
    
    //新增基层单位输入框添加事件
    addNewCompanyName(e){
      this.updateInfo.companyName = this.updateInfo.newCompanyName;
      let query = {
        city:this.updateInfo.city,
        userType:this.updateInfo.userType,
        province:this.updateInfo.province
      }
      getCompanyNumByRegion(query).then((res)=>{
        //将新增的基层单位id赋值给自己
        this.updateInfo.companyID = res.data;
        // this.arrUserId[2]=res.data;
        // this.updateInfo.userID = this.arrUserId.join("");
      })
      
    },
    //变电站名称事件
    changeSubstationName(e,option){
      // option.substationNum：这是自定义添加后，返回的变电站ID
      this.updateInfo.substationName = option.substationName //将选中的名称赋值给变电站名称
      if(option.substationName == "自定义"){
        this.updateInfo.stationID = "";
        this.stationsNameType = true;
      }else{
        this.updateInfo.stationID = option.substationNum; //将添加后的变电站Id赋值给变电站Id
        this.stationsNameType = false;
      }
      // this.arrUserId[3] = option.substationNum; 
      // this.updateInfo.userID = this.arrUserId.join("");
      this.$refs.selectSubstationName.blur();
    },
    //获取焦点
    handleFocusSubstationName(){ 
      this.updateInfo.substationName = "";
      this.updateInfo.stationID = "";
    },
    //新增变电站添加事件
    addNewSubstationName(){
      this.updateInfo.substationName =  this.updateInfo.newSubstationName;
      let query = {
        city:this.updateInfo.city,
        companyId:this.updateInfo.companyID,
        province:this.updateInfo.province
      }
      getSubstationNumByCompany(query).then((res)=>{
       this.updateInfo.stationID = res.data;
      //  this.arrUserId[3]=res.data;
      //   this.updateInfo.userID = this.arrUserId.join("");
      })
    },
    //电压等级
    changesubstationVoltageLevel(e){
      this.updateInfo.substationVoltageLevel = e
    },
    //选择产品类
    /**
     * 隐藏用户id和产品编码
     */
    // changeProductCode(e){
    //   this.arrUserId[4] = e;
    //   this.updateInfo.userID = this.arrUserId.join("");
    // },
    //查询列表
    getUserInfo(){
      this.pagination.current = 1;
      this.getTableList()
    },
    //重置
    reset(){
      this.checkType.account = "";
      this.checkType.userId = "";
      //变电站
      this.checkType.substation = [];
      //管理单位
      this.checkType.company = [];
      this.resultCompanyId = [];
      this.checkType.city = [];
      this.checkType.province = [];
      this.areaparam = [];
      this.getTableList()
      this.getSubstationData()
    }
  }
}
</script>

<style scope lang="less">
.account_index {
  width: 100%;
  height: 100%;
}
  .account_top {
    width: 100%;
    height: 80px;
    padding: 0 10px;
    margin:0 0px 10px 0px;
    .choose_type{
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 10px;
      width: 100%;
      height: 100%;
      background: linear-gradient(144deg,#25404e 0%, #2f5c74 100%);
      border: 2px solid #2b76a1;
      .choose_left {
        display: flex;
        gap: 20px;
        margin-left: 20px;
      }
    }
  .choose_type .choose_label {
      font-size: 14px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      color: #ffffff;
      margin-right: 10px;
    }
  }
  .account_bottom {
    width: 100%;
    padding: 0 10px;
    height: calc(100% - 100px);
    .table_box {
      height: 100%;
      border: 2px solid;
      // border-image: linear-gradient(0deg, #375E79 0%, #2b76a1 100%) 1 1;
      border-image: linear-gradient(0deg, #3f83a8 0%, #2b76a1 100%) 2 2;
      background:linear-gradient(-31deg,#3A5E78 0%,#15273F 100%);
      position: relative;
      .table_control {
        position: absolute;
        top: 0px;
        left: 1%;
        padding: 12px 0 12px 12px;
        z-index: 6;
      }
    }
  }
  .btn,.btn:hover,.btn:focus {
    margin-right:10px;
    font-size: 16px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400; 
    line-height: 14px;
    background: linear-gradient(-45deg,#0c96b1 0%, #0fbca1 100%);
    border: 1px solid;
    border-image: linear-gradient(-45deg, #0eb4dd 0%, #01efbc 100%) 1 1;
  }
    

  .formStyle {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    height: 100%;
    padding:10px 0;
    width: 100%;
  }
  .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
    height: 31px !important;
  }
  // .ant-row {
  //   gap:10px !important;
  // }
  .ant-form-horizontal .ant-form-item-label{
    flex-grow: 1 !important;
  }
  .btn {
    margin-right:10px;
    font-size: 16px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400; 
    line-height: 14px;
    background: linear-gradient(-45deg,#0c96b1 0%, #0fbca1 100%);
    border: 1px solid;
    border-image: linear-gradient(-45deg, #0eb4dd 0%, #01efbc 100%) 1 1;
  }
  .btn_quxiao,.btn_quxiao:hover,.btn_quxiao:focus {
    margin-right:24px;
    font-size: 14px;
    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
    font-weight: 400; 
    line-height: 14px;
    background: transparent;
    border: 1px solid;
    border-image: linear-gradient(0deg, #0eb4dd 0%, #01efbc 100%) 1 1;
    padding : 4px 24px
  }
  .btn_ok {
    padding : 4px 24px
  }
  .ant-form-item-has-error .ant-select:not(.ant-select-disabled):not(.ant-select-customize-input) .ant-select-selector {
    background: transparent;
  }
  .ant-input[disabled]{
    color: #fff;
  }
  .deleteText {
        text-align : center;  
        vertical-align: middle; 
        color : #fff; 
        font-size: 18px;
        margin-top : 40px;
    }
  .addBtn{
    background: linear-gradient(-45deg,#0c96b1 0%, #0fbca1 100%);
    border: 1px solid;
    border-image: linear-gradient(-45deg, #0eb4dd 0%, #01efbc 100%) 1 1;
  }
  .addBtn:hover{
    background: linear-gradient(-45deg,#0c96b1 0%, #0fbca1 100%);
    border: 1px solid;
    border-image: linear-gradient(-45deg, #0eb4dd 0%, #01efbc 100%) 1 1;
  }
  .addBtn:focus {
    background: linear-gradient(-45deg,#0c96b1 0%, #0fbca1 100%);
    border: 1px solid;
    border-image: linear-gradient(-45deg, #0eb4dd 0%, #01efbc 100%) 1 1;
  }
 
</style>